import styled from "styled-components";

export const GameJackpotValueDefaultBox = styled.div`
        width: 100%;
        white-space: nowrap;
        word-break: break-all;
`